import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import useViewContext from '@modules/order/hooks/use-view-context'
import React, { FC, memo } from 'react'
import { useObserver } from 'mobx-react-lite'
import formatNumberByLocale from '@utils/format-number-by-locale'
import HierarchyCell from '@modules/order/components/CellTemplates/components/HierarchyCell/HierarchyCell'
import FieldSkeleton from '@api/order/components/CellLoaders/FieldSkeleton'
import { CentricTypography } from '@core/component/CentricTypography'
import { CATEGORY_INTERNAL_SEPERATOR } from '@modules/order/constants/uiConstants'
import { InitialAllocationUIStore } from '@modules/showroom/EnhancedOrder/stores/EnhancedListView/InitialAllocationUIStore'
import { InitialAllocationDataStore } from '@modules/showroom/EnhancedOrder/stores/EnhancedListView/InitialAllocationDataStore'

const IADoorLevelHierarchyCell: FC<CellItem> = ({ rowData, column }) =>
  useObserver(function useHook() {
    const { uiStore } = useViewContext()

    const { getDoorOrderHierarchyKPIs, dataStore } =
      uiStore as InitialAllocationUIStore<InitialAllocationDataStore>
    const { field } = column
    const isMainHeirarchy = !rowData?.name?.includes(CATEGORY_INTERNAL_SEPERATOR)
    const doorOrder = getDoorOrderHierarchyKPIs(
      field,
      rowData?.name,
      dataStore.totalDoorKPIs
    )

    const qtyValueStr = `${formatNumberByLocale(
      doorOrder?.totalDoorQuantity || 0
    )} /  ${formatNumberByLocale(doorOrder?.totalDeliveryDoorQuantity || 0)}`

    if (!rowData) {
      return (
        <HierarchyCell>
          <FieldSkeleton />
        </HierarchyCell>
      )
    }
    return (
      <HierarchyCell data-test-id='IADoorLevelHierarchyCell'>
        <CentricTypography variant={isMainHeirarchy ? 'subtitle1' : 'caption'}>
          {qtyValueStr}
        </CentricTypography>
      </HierarchyCell>
    )
  })

export default memo(IADoorLevelHierarchyCell)
